import { lazy } from "react";
import { Route, Routes } from "react-router";
import { AppLayout } from "./components/AppLayout";

// Route-level code splitting: the workbook reader and charts load with the calculators.
const HomePage = lazy(() => import("./pages/HomePage").then((m) => ({ default: m.HomePage })));
const RainfallPage = lazy(() => import("./pages/RainfallPage").then((m) => ({ default: m.RainfallPage })));
const FlowPage = lazy(() => import("./pages/FlowPage").then((m) => ({ default: m.FlowPage })));
const InfiltrationPage = lazy(() => import("./pages/InfiltrationPage").then((m) => ({ default: m.InfiltrationPage })));
const DocPage = lazy(() => import("./pages/DocPage").then((m) => ({ default: m.DocPage })));
const NotFoundPage = lazy(() => import("./pages/NotFoundPage").then((m) => ({ default: m.NotFoundPage })));

export function App() {
  return (
    <Routes>
      <Route element={<AppLayout />}>
        <Route index element={<HomePage />} />
        <Route path="rainfall" element={<RainfallPage />} />
        <Route path="flow" element={<FlowPage />} />
        <Route path="infiltration" element={<InfiltrationPage />} />
        <Route path="docs/*" element={<DocPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
